'use client';
import { FunctionComponent } from 'react';
import Company from '@business/general/Company';
import ALink from '@xFrame4/components/next/ALink';
import AppTracker from '@components/tracking/AppTracker';
import { useTranslate } from '@xFrame4/components/Hooks';

export interface HeaderCompanyInfoProps
{
    language: string;
    company: Company;
}

/**
 * Component: essential company info in the desktop header
 */
const HeaderCompanyInfo: FunctionComponent<HeaderCompanyInfoProps> = (props) =>
{
    const t = useTranslate();
    const company = Company.createFromJson(props.company) as Company;
    const companyTranslation = company.getTranslation(props.language);

    /** Render */
    return (
        <div className="header-company-info d-flex align-items-center">
            {(companyTranslation?.addressLine1 || companyTranslation?.cityName) &&
                <div className="header-address me-4">
                    <ALink
                        href={`https://maps.app.goo.gl/ZdUZhuF2otVFGePe9`}
                        className="text-decoration-none d-flex align-items-center"
                        target="_blank"
                        onClick={() => AppTracker.trackAddressClick()}
                    >
                        <i className="fas fa-map-marker-alt me-2 text-muted"></i>
                        <span className="text-dark">
                            {companyTranslation?.addressLine1}
                            {companyTranslation?.addressLine2 &&
                                <span>, {companyTranslation.addressLine2}</span>
                            }
                            {companyTranslation?.cityName &&
                                <span>, {companyTranslation.cityName}</span>
                            }
                            {company.postalCode &&
                                <span>, {company.postalCode}</span>
                            }
                        </span>
                    </ALink>
                </div>
            }
            {company.phone && 
                <div className="header-phone me-4">
                    <ALink 
                        href={`tel:${company.phone}`} 
                        className="text-decoration-none d-flex align-items-center" 
                        onClick={() => AppTracker.trackPhoneClick()}
                    >
                        <i className="fas fa-phone me-2 text-muted"></i>
                        <span className="text-dark">{company.phone}</span>
                    </ALink>
                </div>
            }
            {company.email && 
                <div className="header-email">
                    <ALink 
                        href={`mailto:${company.email}`} 
                        className="text-decoration-none d-flex align-items-center" 
                        onClick={() => AppTracker.trackEmailClick()}
                    >
                        <i className="fas fa-envelope me-2 text-muted"></i>
                        <span className="text-dark">{company.email}</span>
                    </ALink>
                </div>
            }
        </div>
    );
}

export default HeaderCompanyInfo;